import React, { useState } from "react";
// import yesIcon from "../../images/YES.svg";
// import noIcon from "../../images/NO.svg";
import { Grid, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import { isEmpty, range } from "lodash";
// import Draggable from "react-draggable";
// import "animate.css/animate.css";


const DropableLabel = (props) => {
  const {
    label,
    right,
    marginTop,
    rotate,
    classes
  } = props;

  return (
    <div style={{ position: "absolute", borderRadius: 10, marginTop: marginTop, left: right,  transform: rotate, zIndex: 3 }}>
    <h4 className={classes.labelText}>{label}</h4>
  </div>
  );
};

export default withStyles(styles)(DropableLabel);
